module.exports = __webpack_public_path__ + "assets/img/car26.8eac5a12.jpg";